import React, { useState } from 'react';
import CompanyDetails from './CompanyDetails';
import Icon from './Icon';
import { SinatraMark } from './SinatraLogo';
import { industryLabel } from './utils';
import { themeManager } from '../utils/themeManager';
import './CompanyPage.css';

/**
 * The same company details as the docked panel, full-page - for when someone wants more room to
 * work (opened in a new tab via CompanyDetailPanel's "Open in a new tab" button). Reached through
 * App.js reading ?company=<id> from the URL; still behind AuthGate, just not inside Graph.
 */
const CompanyPage = ({ companyId }) => {
  const [theme, setTheme] = useState(() => themeManager.initializeTheme());
  const [header, setHeader] = useState(null);

  if (!companyId) {
    return (
      <div className="company-page">
        <p className="placeholder-text">No company specified. Open this from a company's "Open in a new tab" button.</p>
      </div>
    );
  }

  return (
    <div className="company-page">
      <header className="company-page__header">
        <a href="/" className="company-page__brand"><SinatraMark size={20} /> Sinatra</a>
        <div className="company-page__title">
          <h1>{header?.name || 'Loading...'}</h1>
          {header?.industry && <span className="company-page__industry">{industryLabel(header.industry)}</span>}
        </div>
        <button
          type="button"
          className="company-page__theme"
          onClick={() => setTheme(themeManager.toggleTheme(theme))}
          aria-label={`Switch to ${theme === 'light' ? 'dark' : 'light'} theme`}
          title={`Switch to ${theme === 'light' ? 'dark' : 'light'} theme`}
        >
          <Icon name={theme === 'light' ? 'moon' : 'sun'} />
        </button>
      </header>
      <main className="company-page__body">
        <CompanyDetails companyId={companyId} onHeaderInfo={setHeader} />
      </main>
    </div>
  );
};

export default CompanyPage;
